import React from 'react';
import { WithWistiaContext } from 'utils/WistiaContext';
import WebsiteImage from 'components/WebsiteImage';
import { ThumbnailOnlyContainer } from './styles';

const ThumbnailOnly = ({ thumbnail, setIsPlaying }) => (
  <ThumbnailOnlyContainer className="wistia-video--wrapper" onClick={() => setIsPlaying(true)}>
    <WebsiteImage {...(thumbnail?.image || thumbnail)} />
  </ThumbnailOnlyContainer>
);

export default WithWistiaContext(ThumbnailOnly);
